import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { apiGet } from "helpers/apiService";
import CraftEditorHost from "./craft-editor-host";

const pickTemplateContent = template => {
  const candidates = [
    template?.templateContent,
    template?.TemplateContent,
    template?.landingPageContent,
    template?.content,
  ];
  const found = candidates.find(
    value => typeof value === "string" && value.trim()
  );
  return found || "";
};

const normalizeTemplate = payload => {
  let found =
    payload?.resultData ||
    payload?.data?.resultData ||
    payload?.data?.data ||
    payload?.data ||
    payload ||
    null;

  if (Array.isArray(found)) {
    found = found[0] || null;
  }

  return found;
};

/**
 * Edit loads saved Craft JSON from:
 * GET /api/ProjectMasterLandingPageTemplate/templatebyid?id={id}
 */
const MasterLandingEdit = () => {
  document.title = "Edit Master Landing Page | Realty Space";
  const { id } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTemplate = async () => {
      if (!id) {
        toast.error("Invalid template selected");
        navigate("/master-landing-page");
        return;
      }

      try {
        setLoading(true);

        const response = await apiGet(
          "ProjectMasterLandingPageTemplate/templatebyid",
          { id }
        );

        const found = normalizeTemplate(response?.data ?? response);

        if (!found) {
          toast.error("Template not found");
          navigate("/master-landing-page");
          return;
        }

        setTemplate(found);
      } catch (error) {
        toast.error(
          error?.response?.data?.validationErrors?.[0] ||
            error?.response?.data?.message ||
            "Failed to load template"
        );
        navigate("/master-landing-page");
      } finally {
        setLoading(false);
      }
    };

    fetchTemplate();
  }, [id, navigate]);

  if (loading) {
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content">
          <div className="loading">Loading editor…</div>
        </div>
      </React.Fragment>
    );
  }

  if (!template) return null;

  const templateId =
    template.id || template.projectMasterLandingPageTemplateId || id;

  return (
    <CraftEditorHost
      autoCreate={false}
      syncToApi="master"
      pageId={`master-${templateId}`}
      templateId={templateId}
      templateTitle={template.templateTitle || ""}
      templateDescription={template.templateDescription || ""}
      templateContent={pickTemplateContent(template)}
    />
  );
};

export default MasterLandingEdit;
